<template>
  <div class="page-wrap">
    <el-card shadow="never">
      <div class="toolbar">
        <el-input v-model="query.username" placeholder="用户名称" style="width:220px;margin-right:12px" clearable />
        <el-select v-model="query.auditStatus" placeholder="审核状态" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
        <el-select v-model="query.status" placeholder="到账状态" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in statusOptions2" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
        <el-select v-model="query.storeId" filterable placeholder="门店" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in storeList" :key="opt.id" :label="opt.storename" :value="opt.id" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="fetchList">查询</el-button>
      </div>
      <el-table :data="list" border stripe v-loading="loading" style="width:100%">
        <el-table-column prop="orderNo" label="流水编号" width="300" :show-overflow-tooltip="true"/>
        <el-table-column label="门店名称" prop="storename"/>
        <el-table-column label="提现用户" prop="username"/>
        <el-table-column label="提现银行" prop="bankName"/>
        <el-table-column label="提现卡号" prop="receiverAccountNo"/>
        <el-table-column label="提现金额" prop="price"/>
        <el-table-column label="可提现金额" prop="ktBalance"/>
        <el-table-column label="剩余金额" prop="syBalance"/>
        <el-table-column label="手续费" prop="sxf"/>
        <el-table-column label="提现时间" width="180">
          <template slot-scope="{row}">
            {{formatDate(row.createTime)}}
          </template>
        </el-table-column>
        <el-table-column label="审核时间" width="180">
          <template slot-scope="{row}">
            {{formatDate(row.updateTime)}}
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="130" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <el-tag type="primary" v-if="row.auditStatus == '0'">待审核</el-tag>
            <el-tag type="success" v-else-if="row.auditStatus == '1'">审核成功</el-tag>
            <el-tag type="danger" v-else-if="row.auditStatus == '2'">审核失败</el-tag>
            <span v-if="row.auditError">{{row.auditError}}</span>
          </template>
        </el-table-column>
        <el-table-column label="到账状态" width="130" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.status == '0'">成功</el-tag>
            <el-tag type="warning" v-if="row.status == '2'">银行处理中</el-tag>
            <span v-if="row.msg">{{row.msg}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text"  v-permission="'btn:bf:balance:audit:audit'" @click="auditOpen(row)" v-if="row.auditStatus === '0'">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
            background
            layout="total, prev, pager, next, sizes"
            :total="total"
            :current-page.sync="query.page"
            :page-size.sync="query.pageSize"
            :page-sizes="[10,20,50,100]"
            @current-change="fetchList"
            @size-change="fetchList"
        />
      </div>
    </el-card>

    <el-dialog
        title="提现审核"
        :visible.sync="auditVisible">
      <el-form :model="auditForm" :rules="auditRules" ref="qkFormRef" label-width="100px">
        <el-form-item label="审核状态" prop="auditStatus">
          <el-switch active-value="1" inactive-value="2" v-model="auditForm.auditStatus" @change="handleAuditChange"></el-switch>
        </el-form-item>
        <el-form-item label="拒绝原因" prop="auditError" v-if="auditForm.auditStatus === '2'">
          <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入拒绝原因"
              v-model="auditForm.auditError">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitAudit" v-loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 说明：接口路径与后端保持一致，下面以 /api/open-account 为示例
import axios from 'axios'
export default {
  name: 'OpenAccountList',
  data(){
    return {
      btnLoading:false,
      auditVisible:false,
      loading:false,
      list:[],
      storeList:[],
      total:0,
      query:{
        page:1,
        pageSize:10,
        username:'',
        auditStatus:null,
        storeId: null,
        type: '3'
      },
      statusOptions:[
        {label:'审核中', value:'0'},
        {label:'审核成功', value:'1'},
        {label:'审核失败', value:'2'}
      ],
      statusOptions2:[
        {label:'成功', value:'0'},
        {label:'失败', value:'1'}
      ],
      auditForm: {
        id: null,
        uid: null,
        blankId: null,
        price: null,
        sxf: null,
        username: null,
        storeId: null,
        orderNo: null,
        auditStatus: '1',
        auditError: null
      },
      auditRules: {
        auditError:[]
      }
    }
  },
  created(){
    this.fetchList();
    this.getList();
  },
  methods:{
    async getList(){
      const { data:res } = await axios.get('/bf-audit/getStoresAll')
      console.log('=========')
      console.log(res)
      this.storeList = res.data
    },
    async fetchList(){
      this.loading=true
      try{
        const {data} = await axios.post('/bf-audit/list/',this.query)
        if(data.code == 200){
          this.list=data.data.list||[]
          this.total=data.data.total||0
        }else{ this.$message.error(data.msg||'查询失败') }
      }catch(e){ this.$message.error('查询异常'); console.error(e) }
      finally{ this.loading=false }
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    auditOpen(row){
      this.auditForm.id = row.id;
      this.auditForm.uid = row.uid;
      this.auditForm.price = row.price;
      this.auditForm.sxf = row.sxf;
      this.auditForm.username = row.username;
      this.auditForm.storeId = row.storeId;
      this.auditForm.blankId = row.blankId;
      this.auditForm.orderNo = row.orderNo;
      this.auditForm.auditStatus = '1';
      this.auditForm.auditError = null;
      this.auditRules.auditError = []
      this.auditVisible = true
    },
    handleSubmitAudit() {
      this.$refs.qkFormRef.validate(valid => {
        if (!valid) return

        this.btnLoading = true

        // 提交数据：在此处调用 API
        axios.post('/bf-audit/audit', this.auditForm)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('审核成功')
              this.fetchList()
              this.auditVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => this.$message.error('审核失败'))
            .finally(() => this.btnLoading = false)
      })
    },
    handleAuditChange(val) {
      this.auditRules.auditError = []
      if (val == '2') {
        this.auditRules.auditError = [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' },
          { max: 100, message: '最大长度为100字符', trigger: 'change' }
        ]
      }
    }
  }
}
</script>

<style scoped>
.page-wrap{ padding:12px }
.toolbar{ display:flex; align-items:center; margin-bottom:12px }
.pager{ margin-top:12px; text-align:right }
</style>
